import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getOfferMerchants = createAsyncThunk(
  "offer/merchants",
  async (thunkAPI) => {
    try {
      const response = await axios.get(`merchant?limit=${100}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getMerchantProfiles = createAsyncThunk(
  "merchat/profiles",
  async (payload, thunkAPI) => {

    try {
      const response = await axios.get(`merchant/profiles/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);


export const getMerchants = createAsyncThunk(
  "merchants",
  async (payload, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams();
      if (payload?.page) queryParams.append("page", payload.page);
      if (payload?.limit) queryParams.append("limit", payload.limit);
      if (payload?.search) queryParams.append("search", payload.search);
      if (payload?.contactSearch) queryParams.append("contactSearch", payload.contactSearch);
      if (payload?.dateSearch) queryParams.append("dateSearch", payload.dateSearch);
      if (payload?.status) queryParams.append("status", payload.status);
      if (payload?.duration) queryParams.append("duration", payload.duration);
      if (payload?.startDate) queryParams.append("startDate", payload.startDate);
      if (payload?.endDate) queryParams.append("endDate", payload.endDate);
      const queryString = queryParams.toString();
      const url = queryString ? `merchant?${queryString}` : "merchant";
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getFundraisers = createAsyncThunk(
  "fundraiser",
  async (payload, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams();

      // Add all available parameters to the query string
      if (payload?.page) queryParams.append("page", payload.page);
      if (payload?.limit) queryParams.append("limit", payload.limit);
      if (payload?.search) queryParams.append("search", payload.search);
      if (payload?.status) queryParams.append("status", payload.status);
      if (payload?.duration) queryParams.append("duration", payload.duration);

      // Build the final URL with all query parameters
      const queryString = queryParams.toString();
      const url = queryString ? `fundraiser/all?${queryString}` : "fundraiser";
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getMerchantInquiries = createAsyncThunk(
  "inquiry/merchant",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(
        `inquiry/merchant?page=${payload?.page}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const toggleMerchantStatus = createAsyncThunk(
  "merchant/status",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(`merchant/status/${payload?.id}`, {
        reason: payload?.reason,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const redeemOffer = createAsyncThunk(
  "offerRedeem/redeemOffer",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      // Build the URL dynamically based on whether selectedMerchant exists
      const baseUrl = "offerRedeem/redeemOffer";
      const withMerchantUrl = (selectedMerchant && selectedMerchant._id)
        ? `${baseUrl}?merchantId=${selectedMerchant._id}`
        : baseUrl;

      try {
        const response = await axios.post(withMerchantUrl, { code: payload?.code });
        return response?.data;
      } catch (err) {
        // If backend says this merchant isn't the owner, retry without merchantId to allow validation
        const msg = err?.response?.data?.message || "";
        const status = err?.response?.status;
        const isOwnerMismatch = status === 403 && /not allowed to redeem this offer because you are not the owner/i.test(msg);
        if (isOwnerMismatch && withMerchantUrl !== baseUrl) {
          try {
            const retry = await axios.post(baseUrl, { code: payload?.code });
            return retry?.data;
          } catch (_) {
            throw err;
          }
        }
        throw err;
      }
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const checkRedemptionCode = createAsyncThunk(
  "offerRedeem/checkCode",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      const baseUrl = "offerRedeem/checkCode";
      const withMerchantUrl = (selectedMerchant && selectedMerchant._id)
        ? `${baseUrl}?merchantId=${selectedMerchant._id}`
        : baseUrl;

      try {
        const response = await axios.post(withMerchantUrl, { code: payload?.code });
        return response?.data;
      } catch (err) {
        const msg = err?.response?.data?.message || "";
        const status = err?.response?.status;
        const isOwnerMismatch = status === 403 && /not allowed/i.test(msg);
        if (isOwnerMismatch && withMerchantUrl !== baseUrl) {
          try {
            const retry = await axios.post(baseUrl, { code: payload?.code });
            return retry?.data;
          } catch (_) {
            throw err;
          }
        }
        throw err;
      }
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getVerificationStats = createAsyncThunk(
  "offerRedeem/verificationStats",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const selectedMerchant = state.merchantReducer.selectedMerchent;
      const params = selectedMerchant ? { merchantId: selectedMerchant._id } : {};
      const response = await axios.get("offerRedeem/verificationStats", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

//Analytics
export const fetchNewCustomerOffers = createAsyncThunk(
  "offerRedeem/newCustomers",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    const params = selectedMerchant ? { merchantId: selectedMerchant._id } : {};
    try {
      const response = await axios.get("offerRedeem/newCustomers", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const fetchofferRedeemPercentage = createAsyncThunk(
  "offerRedeem/percentage",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    const params = selectedMerchant ? { merchantId: selectedMerchant._id } : {};
    try {
      const response = await axios.get("offerRedeem/percentage", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const fetchOfferViewsClicks = createAsyncThunk(
  "offer/views/clicks",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    const params = selectedMerchant ? { merchantId: selectedMerchant._id } : {};
    try {
      const response = await axios.get("offer/views/clicks", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const fetchMerchantMostPopularOffer = createAsyncThunk(
  "merchant/mostPopularOffer",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    const params = selectedMerchant ? { merchantId: selectedMerchant._id } : {};
    try {
      const response = await axios.get("merchant/mostPopularOffer", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getFavouriteOffers = createAsyncThunk(
  "merchant/favouriteOffers",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const selectedMerchant = state.merchantReducer.selectedMerchent;
      const params = selectedMerchant
        ? { merchantId: selectedMerchant._id }
        : {};
      const response = await axios.get("merchant/countOfFavoriteOffers", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getAboutPageViews = createAsyncThunk(
  "merchant/aboutPageViews",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const selectedMerchant = state.merchantReducer.selectedMerchent;
      const params = selectedMerchant
        ? { merchantId: selectedMerchant._id }
        : {};
      const response = await axios.get("merchant/getAboutPageView", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getDashboardStats = createAsyncThunk(
  "merchant/stats",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const selectedMerchant = state.merchantReducer.selectedMerchent;
      const params = selectedMerchant
        ? { merchantId: selectedMerchant._id }
        : {};
      const response = await axios.get("offerRedeem/dashboardStats", {
        params,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getRedemptionByDemographics = createAsyncThunk(
  "merchant/demographics",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const selectedMerchant = state.merchantReducer.selectedMerchent;
      const params = selectedMerchant
        ? { merchantId: selectedMerchant._id }
        : {};
      const response = await axios.get(
        "merchant/getOfferRedemptionByDemographics",
        { params }
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getRedemptionRates = createAsyncThunk(
  "merchant/redemptionRate",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      let url = `offerRedeem/redemptionRate`;
      const params = {};
      if (selectedMerchant?._id) params.merchantId = selectedMerchant._id;
      if (payload?.timePeriod) params.timePeriod = payload.timePeriod;
      const queryString = new URLSearchParams(params).toString();
      if (queryString) url += `?${queryString}`;

      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getRedeemedFrequencies = createAsyncThunk(
  "merchant/redeemedFrequency",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const selectedMerchant = state.merchantReducer.selectedMerchent;
    try {
      let url = `offerRedeem/redemptionFrequency`;
      const params = {};
      if (selectedMerchant?._id) params.merchantId = selectedMerchant._id;
      if (payload?.timePeriod) params.timePeriod = payload.timePeriod;
      const queryString = new URLSearchParams(params).toString();
      if (queryString) url += `?${queryString}`;

      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getMerchantById = createAsyncThunk(
  "merchant/get",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(`merchant/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const approveOrRejectMerchant = createAsyncThunk(
  "admin/updateMerchantStatus",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(
        "admin/updateMerchantStatus",
        payload
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Delete Merchant (pending only) by id
export const deleteMerchantById = createAsyncThunk(
  "merchant/delete",
  async (payload, thunkAPI) => {
    try {
      // payload: { id }
      const response = await axios.delete(`admin/${payload?.id}/delete-pending`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error?.response?.data || error);
    }
  }
);

// Get Merchant Business Profile
export const getMerchantBusinessProfile = createAsyncThunk(
  "merchant/business-profile/get",
  async (payload, thunkAPI) => {
    try {
      // Primary admin-safe endpoint
      const response = await axios.get(`merchant/business-profile/${payload.id}`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { _: Date.now() },
      });
      if (response?.data?.success === true) {
        return response?.data;
      }
      // Wrap unexpected responses in a proper Error for upstream handlers
      const err = new Error(response?.data?.message || "Failed to fetch business profile");
      err.status = response?.status;
      err.data = response?.data;
      throw err;
    } catch (error) {
      // Fallbacks for environments where RBAC routes differ
      try {
        const alt1 = await axios.get(`merchant/${payload.id}`, {
          headers: { 'Cache-Control': 'no-cache' },
          params: { _: Date.now() },
        });
        if (alt1?.data) return alt1?.data;
      } catch (_) { }
      try {
        const alt2 = await axios.get(`merchant/profile/${payload.id}`, {
          headers: { 'Cache-Control': 'no-cache' },
          params: { _: Date.now() },
        });
        if (alt2?.data) return alt2?.data;
      } catch (_) { }

      return thunkAPI?.rejectWithValue(error?.response?.data || error);
    }
  }
);

// Update Merchant Business Profile
export const updateMerchantBusinessProfile = createAsyncThunk(
  "merchant/business-profile/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await axios.patch(`merchant/business-profile/${id}`, data);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error?.response?.data || error);
    }
  }
);